import React from 'react';
import { useParallax } from 'react-scroll-parallax';
import FooterLogo from './FooterLogo';
import NavLinks from '../Header/NavLinks';
import SocialMediaIcons from '../Header/SocialMediaIcons';
import FooterNewsletter from './FooterNewsletter';

const LocationInformation: React.FC = () => (
  <div className="flex flex-col items-center">
    <a
      href="tel:+18056795657"
      className="text-maroon font-charles text-xl lg:text-7xl"
    >
      (805) 679-5657
    </a>
    <a
      href="https://maps.app.goo.gl/zSPGCo7ESQsUVDE77"
      className="text-sea font-prosto text-xs lg:text-lg"
    >
      1230 State St. STE C, Santa Barbara, CA 93101
    </a>
  </div>
);

const Footer: React.FC = () => {
  /*
   * Define parallax for each element. We use small, subtle
   * transformations so they gently "float up".
   * Tweak numbers to get your desired effect.
   */

  // Jellyfish #1
  const jelly1Ref = useParallax<HTMLDivElement>({
    translateY: [40, 0], // starts 40px lower, ends at 0
    easing: 'easeInOut',
  });

  // Jellyfish #2 (flipped). We use a wrapper so scale-x doesn't clash with parallax.
  const jelly2Ref = useParallax<HTMLDivElement>({
    translateY: [60, 0],
    easing: 'easeInOut',
  });

  // Bubbles
  const bubblesRef = useParallax<HTMLDivElement>({
    translateY: [20, 0],
    easing: 'easeInOut',
  });

  return (
    <footer className="relative">
      {/* Jelly #1 in wrapper to apply parallax */}
      <div
        ref={jelly1Ref.ref}
        className="absolute -top-8 left-12 w-[20vw] z-[0]"
      >
        <img
          src="https://santaplaya-bucket.s3.amazonaws.com/blueJellyfish.webp"
          alt="Blue Jellyfish 1"
          className="w-full h-auto"
        />
      </div>

      {/* Jelly #2 in wrapper for parallax + scale-x flip */}
      <div
        ref={jelly2Ref.ref}
        className="absolute -top-40 right-1/4 w-[20vw] z-[0]"
      >
        <img
          src="https://santaplaya-bucket.s3.amazonaws.com/blueJellyfish.webp"
          alt="Blue Jellyfish 2"
          className="w-full h-auto scale-x-[-1]"
        />
      </div>

      {/* Bubbles in wrapper */}
      <div
        ref={bubblesRef.ref}
        className="absolute top-16 right-[12.5%] w-[3vw] z-[-1]"
      >
        <img
          src="https://santaplaya-bucket.s3.amazonaws.com/FooterBubbles.webp"
          alt="Footer Bubbles"
          className="w-full h-auto"
        />
      </div>

      {/* Main Footer Content */}
      <div className="bg-transparent text-sea px-6 py-8 xl:px-56 xl:py-24 relative z-10 overflow-y-hidden">
        <div className="flex flex-col items-center justify-center space-y-16">
          <FooterLogo />
          <NavLinks />
          <SocialMediaIcons />
          <LocationInformation />
          <FooterNewsletter />
        </div>
      </div>

      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/BottomOfSea.webp"
        className="w-full"
        alt="Bottom of the Sea"
      />
    </footer>
  );
};

export default Footer;
